angular.module('cn')

.component('createnetwork', {
  controller: [
    '$q',
    '$rootScope',
    '$location',
    '$http',
    '$route',
    'networksRepository',
    'networkTypesRepository',
    function(
      $q,
      $rootScope,
      $location,
      $http,
      $route,
      networksRepository,
      networkTypesRepository
    ) {
      var $ctrl = this;

      this.$onInit = function() {
        $ctrl.network = $ctrl.resolve.network;
        if ($ctrl.network) {
          $ctrl.name = $ctrl.network.name;
        }
        $ctrl.typs = [];
        networkTypesRepository.getAll().then(function(types) {
          $ctrl.types = types;
          if ($ctrl.network) {
            $ctrl.types.find(function(t) {
              return t.id === $ctrl.network.type;
            }).checked = true;
          }
        });
      };

      this.uncheckOthers = function(type) {
        $ctrl.types.forEach(function(t) {
          if (t.id !== type.id) {
            t.checked = false;
          }
        });
        return false;
      };

      this.create = function() {
        networksRepository.create({
          name: $ctrl.name,
          type: $ctrl.types.find(function(t) { return t.checked; })
        }).then(function(network) {
          $location.path('/networks/crud/' + network.id);
          $rootScope.$emit('onBackendSuccess', 'Network created successfully');
        }).finally(function() {
          $ctrl.close();
        });
      };

      this.enableSave = function() {
        if (!$ctrl.name) {
          return false;
        }
        if ($ctrl.types && !$ctrl.types.find(function(t) { return t.checked; })) {
          return false;
        }
        return true;
      };

      this.save = function() {
        networksRepository.save($ctrl.network, {
          name: $ctrl.name,
          type: $ctrl.types.find(function(t) { return t.checked; })
        }).then(function(network) {
          $ctrl.close({$value: network});
          $rootScope.$emit('onBackendSuccess', 'Network saved successfully');
        }).finally(function() {
          $ctrl.close();
        });
      };

    }
  ],
  template: require('./createnetwork.html'),
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./src/cn/createnetwork.js